import { render, staticRenderFns } from "./VentasAbonosComponent.vue?vue&type=template&id=42f68d4a"
import script from "./VentasAbonosComponent.vue?vue&type=script&lang=js"
export * from "./VentasAbonosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports